import React from 'react';

import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').GenericCardsBlock}
 */

const GenericCards = ({
    title,
    text,
    backgroundColor,
    cards,
    ctaCssClass,
    ctaLabel,
    ctaLink
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} pb-8 md:pb-16 pt-24 col-padding rounded-lg flex-grow`}>
            <h2 className='type-style-sans-h1 w-full sm:w-8/12 md:w-7/12'>
                {title}
            </h2>
            {text && (
                <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                    {text}
                </p>
            )}
            <div className='mt-24 md:mt-40 sm:grid-cols-4 gap-8 md:gap-16 grid'>
                {cards.map((partner) => {
                    return (
                        <div
                            className='bg-surface-raised p-16 rounded-lg grid grid-y-16 grid-rows-subgrid'
                            key={partner.id}
                            style={{ gridRow: 'span 2'}}>
                            <p className='type-style-sans-h3-med'>
                                {partner.title}
                            </p>
                            {partner.text && (
                                <p className='type-style-sans-body'>
                                    {partner.text}
                                </p>
                            )}
                        </div>
                    );
                })}
            </div>
            {ctaLabel && (
                <Button
                    as='a'
                    className={`mt-24 md:mt-40 button-primary-xl${ctaCssClass ? ' ' + ctaCssClass : ''}`}
                    href={formatLinkBlockToUrl(ctaLink)}>
                    {ctaLabel}
                </Button>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default GenericCards;
